<template>
  <row-item class="show-my-team-bar"
            :type="type"
            :disabled="disabled"
            @click="showTeamDetail"
  >
    查看拼团进度
  </row-item>
</template>

<script>
  import RowItem from '@/components/YmTabbarItem/Row';

  export default {
    name: 'ProductDetailBottomShowMyTeamBar',
    components: {
      RowItem,
    },
    data() {
      return {
        disabled: false,
      };
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        default: 'gradient-primary',
      },
    },
    methods: {
      showTeamDetail() {
        this.disabled = true;
        const route = { name: 'GroupBuyTeamDetail', params: { id: this.id } };
        this.$router.push(route);
        this.disabled = false;
      },
    },
  };
</script>

<style lang="less">
  @import '~@/assets/styles/var.less';

  .show-my-team-bar {
    margin-left: @size-base;
    border-radius: 50px;
  }
</style>
